import { Card, useWindowWidth } from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';

import { MOBILE_WIDTH } from '@/constants';

import { TProgram } from '../../types';

import { ProgramDetail } from './components';

type ProgramDetailsCardProps = {
  program: TProgram;
  isCollapsed: boolean;
  onCollapse: () => void;
  onUpdate: (program: TProgram) => void;
};

export function ProgramDetailCard({
  onCollapse,
  isCollapsed,
  program,
  onUpdate,
}: ProgramDetailsCardProps) {
  const { width } = useWindowWidth();
  const isMobile = width < MOBILE_WIDTH;
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card
      className="w-full"
      title={program.name}
      isAccordion={isMobile}
      isCollapsable={!isMobile}
      isOpen={isOpen}
      collapseDirection="right"
      lineSeparator={true}
      isCollapsed={isCollapsed && !isMobile}
      onCollapse={onCollapse}
      onOpen={() => setIsOpen(!isOpen)}
      classes={{
        header: clsx(!isMobile && 'py-3'),
      }}
    >
      <div className="body flex flex-col gap-size-12 self-stretch">
        <ProgramDetail program={program} onUpdate={onUpdate} />
      </div>
    </Card>
  );
}
